import React from 'react'
import "./Contact.css"
const Contact = () => {
  return (
    <>
        <section className="contact" id='contact'>
                <div className="first">
                    <h1 className="heading">Contact Us Anytime</h1>
                    <p className="desc">Get a estimated free quotation by contacting us, within 24 hours we’ll connect with you.
                    </p>
                    <div className="contactinfo">
                        <div className="item">
                            <img src="./images/icons8-location-16.png" alt="" />
                            <p>Location <span>Q-434,Sukanta Nagar, kolkata - 700098</span>
                            </p>
                        </div>
                        <div className="item">
                            <img src="./images/icons8-gmail-16.png" alt="" />
                            <p>Email <span><a href='mailto:sastech004@gmail.com'>sastech004@gmail.com</a></span>
                            </p>
                        </div>
                        <div className="item">
                            <img src="./images/icons8-call-16.png" alt="" />
                            <p>Contact <span><a href='tel:8240402210'>8240402210</a></span>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
    </>
  )
}

export default Contact